var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"text-center text-danger"},[_c('h1',[_vm._v("Stránku sa nepodarilo nájsť.")]),_c('b-img',{staticClass:"mt-5",attrs:{"src":"/logos/pmat-no-margin.svg","fluid":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }